import React from 'react';
import { Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslate } from 'hooks/use-translate';

interface Props {
  expanded: boolean;
  onToggle: () => void;
  /** The region it opens, when the rows are one element (a card's `dl`). */
  controls?: string;
  className?: string;
}

/**
 * N1 (D-92): the "details" expand of a mobile card -- the heavy grid's and the
 * light grid's cards and the table-as-cards rows (task manager, clinical
 * meetings). A muted text button: it discloses the rest of the row, it is not
 * the card's action. Each card sheet places and sizes it (the
 * `mobile-card-toggle` mixin); the chevron turns with `aria-expanded`.
 */
export const CardDetailsToggle: React.FC<Props> = ({ expanded, onToggle, controls, className }) => {
  const { t } = useTranslate();
  return (
    <Button
      className={className}
      color="primary"
      size="small"
      aria-expanded={expanded}
      aria-controls={expanded ? controls : undefined}
      endIcon={<ExpandMoreIcon />}
      onClick={onToggle}
    >
      {t('details')}
    </Button>
  );
};
